var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheatBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2990",
    "data-name": "Group 2990",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.584,
    height: 17.538,
    viewBox: "0 0 21.584 17.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_1021",
    "data-name": "Line 1021",
    d: "M9.271,9.638a.366.366,0,0,1-.259-.107L-1.393-.874a.367.367,0,0,1,0-.519.367.367,0,0,1,.519,0L9.531,9.012a.367.367,0,0,1-.259.626Z",
    transform: "translate(6.66 6.66)",
    fill: "#22294D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M5.852,25.752a.366.366,0,0,1,.074.008c.02,0,.489.1,1.017.252A3.3,3.3,0,0,1,8.4,26.66a1.42,1.42,0,1,1-2.008,2.008,3.3,3.3,0,0,1-.648-1.458c-.151-.528-.248-1-.252-1.017a.367.367,0,0,1,.359-.441Zm1.545,2.6a.687.687,0,0,0,.486-1.172,3.062,3.062,0,0,0-1.141-.461c-.139-.04-.275-.076-.4-.107.032.125.068.262.108.4a3.053,3.053,0,0,0,.46,1.137A.682.682,0,0,0,7.4,28.351Z",
    transform: "translate(-3.422 -23.689)",
    fill: "#22294D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M19.369,29.3h0a1.42,1.42,0,0,1-1.388-1.127,3.3,3.3,0,0,1,.253-1.575c.162-.525.336-.971.344-.99a.367.367,0,0,1,.6-.127c.014.014.354.352.714.767a3.3,3.3,0,0,1,.868,1.339,1.42,1.42,0,0,1-1.1,1.683A1.428,1.428,0,0,1,19.369,29.3Zm-.307-2.878c-.042.122-.086.257-.129.4a3.05,3.05,0,0,0-.235,1.2.686.686,0,0,0,.814.53.687.687,0,0,0,.53-.814,3.062,3.062,0,0,0-.7-1.009C19.243,26.62,19.149,26.515,19.062,26.422Z",
    transform: "translate(-11.699 -23.438)",
    fill: "#22294D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M27.134,37.064h0a1.42,1.42,0,0,1-1.388-1.127A3.305,3.305,0,0,1,26,34.362c.162-.525.336-.971.343-.99a.367.367,0,0,1,.6-.127c.014.014.354.352.714.767a3.3,3.3,0,0,1,.868,1.339,1.42,1.42,0,0,1-1.1,1.683A1.428,1.428,0,0,1,27.134,37.064Zm-.307-2.878c-.042.122-.086.257-.129.4a3.054,3.054,0,0,0-.235,1.2.686.686,0,0,0,.814.53.687.687,0,0,0,.53-.813,3.06,3.06,0,0,0-.7-1.009C27.007,34.384,26.913,34.28,26.827,34.186Z",
    transform: "translate(-16.851 -28.59)",
    fill: "#22294D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M34.9,44.829h0A1.42,1.42,0,0,1,33.51,43.7a3.3,3.3,0,0,1,.253-1.575c.162-.525.336-.971.344-.99a.367.367,0,0,1,.6-.127c.014.014.354.352.714.766a3.3,3.3,0,0,1,.868,1.339,1.42,1.42,0,0,1-1.1,1.683A1.429,1.429,0,0,1,34.9,44.829Zm-.307-2.878c-.042.122-.086.257-.129.4a3.053,3.053,0,0,0-.235,1.2.686.686,0,0,0,.814.53.687.687,0,0,0,.53-.814,3.052,3.052,0,0,0-.7-1.006C34.774,42.151,34.679,42.045,34.592,41.951Z",
    transform: "translate(-22.004 -33.743)",
    fill: "#22294D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M42.662,52.592h0a1.42,1.42,0,0,1-1.388-1.127,3.3,3.3,0,0,1,.253-1.575c.162-.525.336-.971.344-.99a.367.367,0,0,1,.6-.127c.014.014.354.352.714.767a3.3,3.3,0,0,1,.868,1.339,1.419,1.419,0,0,1-1.1,1.682A1.426,1.426,0,0,1,42.662,52.592Zm-.306-2.878c-.042.122-.086.257-.129.4a3.054,3.054,0,0,0-.235,1.2.689.689,0,0,0,.67.545h0a.692.692,0,0,0,.143-.015.686.686,0,0,0,.53-.813,3.061,3.061,0,0,0-.7-1.009C42.536,49.912,42.442,49.808,42.356,49.714Z",
    transform: "translate(-27.156 -38.894)",
    fill: "#22294D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M7.614,41.058a1.428,1.428,0,0,1-.294-.031,3.3,3.3,0,0,1-1.338-.868c-.414-.36-.752-.7-.767-.714a.367.367,0,0,1,.127-.6,9.144,9.144,0,0,1,2.333-.618,1.117,1.117,0,0,1,.232.022,1.42,1.42,0,0,1-.292,2.81ZM6.154,39.33c.095.088.2.183.311.279a3.053,3.053,0,0,0,1.006.7.687.687,0,1,0,.283-1.344.407.407,0,0,0-.08-.006A6.21,6.21,0,0,0,6.154,39.33Z",
    transform: "translate(-3.172 -31.966)",
    fill: "#22294D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M15.379,48.823a1.428,1.428,0,0,1-.294-.031,3.3,3.3,0,0,1-1.338-.868c-.414-.36-.752-.7-.767-.714a.367.367,0,0,1,.127-.6,9.144,9.144,0,0,1,2.333-.618,1.117,1.117,0,0,1,.232.022,1.42,1.42,0,0,1-.292,2.81Zm-1.459-1.728c.095.088.2.183.311.279a3.053,3.053,0,0,0,1.006.7.687.687,0,1,0,.283-1.344.408.408,0,0,0-.08-.006A6.2,6.2,0,0,0,13.919,47.095Z",
    transform: "translate(-8.324 -37.119)",
    fill: "#22294D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M23.143,56.588a1.429,1.429,0,0,1-.294-.031,3.3,3.3,0,0,1-1.338-.868c-.414-.36-.752-.7-.767-.714a.367.367,0,0,1,.127-.6,9.139,9.139,0,0,1,2.333-.618,1.118,1.118,0,0,1,.233.022,1.42,1.42,0,0,1-.293,2.809Zm-1.459-1.728c.095.088.2.183.311.279a3.054,3.054,0,0,0,1.006.7.687.687,0,0,0,.284-1.343.41.41,0,0,0-.081-.006A6.2,6.2,0,0,0,21.683,54.859Z",
    transform: "translate(-13.476 -42.271)",
    fill: "#22294D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M30.907,64.351a1.427,1.427,0,0,1-.294-.031,3.3,3.3,0,0,1-1.338-.868c-.414-.36-.752-.7-.767-.714a.367.367,0,0,1,.127-.6,9.143,9.143,0,0,1,2.333-.618,1.118,1.118,0,0,1,.232.022,1.42,1.42,0,0,1-.292,2.81Zm-1.459-1.728c.095.088.2.183.311.279a3.053,3.053,0,0,0,1.006.7.687.687,0,0,0,.284-1.344.408.408,0,0,0-.08-.006A6.2,6.2,0,0,0,29.447,62.623Z",
    transform: "translate(-18.628 -47.423)",
    fill: "#22294D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1022",
    "data-name": "Line 1022",
    d: "M-.1.264A.366.366,0,0,1-.362.157L-1.393-.874a.367.367,0,0,1,0-.519.367.367,0,0,1,.519,0L.157-.362a.367.367,0,0,1,0,.519A.366.366,0,0,1-.1.264Z",
    transform: "translate(2.533 2.533)",
    fill: "#22294D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1023",
    "data-name": "Line 1023",
    d: "M.8,1.17a.366.366,0,0,1-.259-.107L-1.393-.874a.367.367,0,0,1,0-.519.367.367,0,0,1,.519,0L1.062.544A.367.367,0,0,1,.8,1.17Z",
    transform: "translate(1.5 6.417)",
    fill: "#22294D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1024",
    "data-name": "Line 1024",
    d: "M.8,1.17a.366.366,0,0,1-.259-.107L-1.393-.874a.367.367,0,0,1,0-.519.367.367,0,0,1,.519,0L1.062.544A.367.367,0,0,1,.8,1.17Z",
    transform: "translate(6.417 1.5)",
    fill: "#22294D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M48.869,64.239a4,4,0,0,1-.488-.03A4.648,4.648,0,0,1,45.728,62.9a.367.367,0,0,1,.509-.528,3.9,3.9,0,0,0,2.233,1.113,2.766,2.766,0,0,0,1.827-.36,1.135,1.135,0,0,0,.531-1.372.938.938,0,0,0-.911-.582.9.9,0,0,0-.734.508.864.864,0,0,0,.066.884.367.367,0,1,1-.614.4,1.638,1.638,0,0,1-.274-.826,1.605,1.605,0,0,1,.164-.783,1.634,1.634,0,0,1,2.99.143,1.838,1.838,0,0,1-.816,2.241A3.362,3.362,0,0,1,48.869,64.239Z",
    transform: "translate(-30.052 -46.7)",
    fill: "#22294D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheatBlue);
export default __webpack_public_path__ + "static/media/wheat_blue.039052f830cda3c88a61eb9a5b9664cc.svg";
export { ForwardRef as ReactComponent };